import { Box, Grid2 } from '@mui/material';
import { FC, PropsWithChildren, ReactNode } from 'react';
import ScrollToTopButton from '@components/ScrollToTopButton';
import { MARGIN_BEFORE_FOOTER } from '@styles/consts';

interface DocumentWithRightSidebarProps extends PropsWithChildren {
    sidebarContent: ReactNode;
    sidebarTestId?: string;
}

const DocumentWithRightSidebar: FC<DocumentWithRightSidebarProps> = ({
    children,
    sidebarContent,
    sidebarTestId,
}) => (
    <Grid2 columns={14} spacing={7} sx={{ mb: MARGIN_BEFORE_FOOTER }} container>
        <Grid2 data-test-id="decision-full-text" size={{ md: 8, xs: 14 }}>
            {children}
            <ScrollToTopButton />
        </Grid2>
        <Grid2 component="aside" data-test-id={sidebarTestId} size={{ md: 6, xs: 14 }}>
            <Box sx={{ mt: 3, overflow: 'auto' }}>{sidebarContent}</Box>
        </Grid2>
    </Grid2>
);

export default DocumentWithRightSidebar;
